<template>
    <div class="project-configuration__wrapper">
        <div class="project-configuration">
            <div class="project-configuration__name">
                {{ project.name }}
            </div>
            <div class="project-configuration__content">
                <div class="project-show__content">
                    <application-display-field
                        v-for="field in projectFields"
                        :key="field.name"
                        :field="field"
                        :data="project"
                    ></application-display-field>
                </div>
            </div>
            <div class="project-configuration__controls">
                <sah-button @click.prevent.native="$emit('close')">
                    {{ $tc("words.close") }}
                </sah-button>
            </div>
        </div>
    </div>
</template>

<script>
import {store, SahButton} from "atom";
const {createNamespacedHelpers} = store;
const {mapState} = createNamespacedHelpers("arcman");
import ApplicationDisplayField from "./ApplicationDisplayField.vue";

/**
 *
 * @vue-prop {Object} warehouse - warehouse
 */
export default {
    name: "project-configuration",
    components: {
        ApplicationDisplayField,
        SahButton,
    },
    props: {
        project: {type: Object, required: true},
    },
    computed: {
        ...mapState(["arcologyConstants"]),
        projectFields() {
            return this.arcologyConstants.PROJECT_FIELDS;
        },
    },
};
</script>

<style scoped lang="scss">
.project-configuration__wrapper::v-deep {
    @apply fixed top-0 left-0 z-10 h-screen w-screen flex flex-row items-center justify-center;
    background-color: $background-wrapper-edit-color;

    .project-configuration {
        @apply w-10/12 flex flex-col rounded;
        background-color: $background-application-color;
        font-size: $font-small;
        max-height: 90%;
    }

    .project-configuration__name {
        @apply font-bold py-3 px-5;
        background-color: $background-card-header-color;
        color: $text-card-header-color;
    }

    .project-configuration__content {
        @apply flex flex-wrap bg-white py-3 px-5 overflow-y-auto;
    }

    .project-configuration__controls {
        @apply flex justify-end py-3 px-5 mt-4;
        background-color: $background-card-footer-color;
    }
}
</style>
